<template>
	<vue-final-modal v-slot="{ params, close }" v-bind="$attrs">
		<div class="modalWrapper systemMessage" style="opacity: 1; align-items: center; justify-content: center; display: flex; width: 100%; height: 100%;">
			<div class="modal systemMessage" style="top: 0;">
				<div class="modalContent">
					<div class="modalDecoration"></div>
					<div class="functionPanel unselectable">
						<a class="closeWindow clickable" @click="onModalClose(close)">
							<div class="decoration" content="Закрыть" v-tippy="{placement: 'bottom'}">
								<i class="action_cancel_tiny_flat_black"></i>
							</div>
						</a>
					</div>
					<div>
						<div class="contentHeader unselectable">
							<h2 class="msAntiScroll drag" draggable="true">
								<span class="building"><span>Поиск игроков Dynasty на день Св. Валентина</span></span>
							</h2>
						</div>
					</div>
					<div class="heightTransitionContent">
						<div class="contentTabulation">
							<div class="tabulationContent scrollable">
								<div class="scrollContentOuterWrapper">
									<div class="scrollContent" style="overflow-y: auto;" :style="{maxHeight: maxHeightInnerContent}">
										<div class="scrollContentInnerWrapper" style="width: auto;">
											<div ng-transclude="">
												<div ng-controller="systemMessageCtrl">
													<div ng-bind-html="systemMessage">
														<font face="tahoma, arial, helvetica, sans-serif"><a href="https://blog.kingdoms.com/en/" target="_blank"><img src="https://blog.kingdoms.com/wp-content/uploads/2024/01/lobby-dynasty.png" data-cmp-info="10"></a></font><br><br><font face="tahoma, arial, helvetica, sans-serif"><span>Дорогие игроки!</span></font><br><div><div><font face="tahoma, arial, helvetica, sans-serif"><span><br></span></font></div><div><font face="tahoma, arial, helvetica, sans-serif"><span>Готовьтесь собирать команду! Сборы начнутся 14.02.2024 в 20:00 по МСК в нашем посольстве Дискорд:</span></font></div></div><div><br></div><font face="tahoma, arial, helvetica, sans-serif"><span><a href="https://discord.gg/nVUVXd6J">Посольство</a></span></font><br><br><font face="tahoma, arial, helvetica, sans-serif"><span>Во время этого события я буду вам помогать, задавая вопросы об игре и различных стилях игры, чтобы вы смогли найти свою пару. После завершения мероприятия я разыграю 10x25 ваучеров на Золото между всеми участниками.</span></font><br><br><font face="tahoma, arial, helvetica, sans-serif"><span>Скоро увидимся!</span></font><br><font face="tahoma, arial, helvetica, sans-serif"><span>Ваша команда Travian Kingdoms</span></font><br><font face="tahoma, arial, helvetica, sans-serif"><span></span></font>
													</div>
												</div>
											</div>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
					<div class="window-overlay"></div>
				</div>
			</div>
		</div>
	</vue-final-modal>
</template>

<style lang="scss">

</style>

<script>
import lib from '@/lib';

export default {
	mixins: lib.mixins,
	props: {
		closeable: {
			type: Boolean,
			default: true,
		},
	},
	data: () => ({
		cancelHover: false,
	}),
	computed: {},
	methods: {
		onModalOpen(){
			if(this.gameModel.soundOn){
				var audio = new Audio('//iwstatic.g.bsrv.su/audio/sounds/IWUIS_1.ogg');
				audio.play();
			}
		},
		onModalClose(close){
			if(this.gameModel.soundOn){
				var audio = new Audio('//iwstatic.g.bsrv.su/audio/sounds/IWUIS_2.ogg');
				audio.play();
			}
			if(close) close();
		},
	},
	mounted(){
		this.onModalOpen();
	},
	beforeDestroy(){
		this.onModalClose();
	},
	components: {},
}
</script>